import { render, staticRenderFns } from "./famille.vue?vue&type=template&id=05b61b5a"
import script from "./famille.vue?vue&type=script&lang=js"
export * from "./famille.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports